import { MenuItem } from 'primeng/api';

export interface MenuItemAdvanced extends MenuItem {
  permission?: string;
  items?: MenuItemAdvanced[];
}

export interface BreadCrumbAction {
  label?: string;
  url?: string;
  action?: any;
  class?: string;
  icon?: string;
  permissions?: any[];
  //could expand to have a function
}
